import { useEffect, useState } from 'react';
import { subscribeToGetLoader } from '../services/api';
import { clsx } from 'clsx';

const HIDE_DELAY_MS = 300;

export default function GlobalTopLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToGetLoader((loading) => {
      setIsLoading(loading);
      if (loading) {
        setIsVisible(true);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!isLoading && isVisible) {
      const timeout = window.setTimeout(() => setIsVisible(false), HIDE_DELAY_MS);
      return () => window.clearTimeout(timeout);
    }
  }, [isLoading, isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={clsx(
        'global-top-loader',
        isLoading ? 'opacity-100' : 'opacity-0'
      )}
    >
      <div className="global-top-loader-track">
        <div className={clsx('global-top-loader-bar', isLoading && 'animate-global-top-loader')} />
        <div className={clsx('global-top-loader-glow', isLoading && 'animate-global-top-loader-glow')} />
      </div>
    </div>
  );
}
